import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-contact-contents',
  templateUrl: './contact-contents.component.html',
  styleUrls: ['./contact-contents.component.scss']
})
export class ContactContentsComponent implements OnInit {

  ContactPages;

  constructor(private router: Router, private TokenService: TokenService, private http: HttpClient) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['ContactContents']) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.http.get<any>(environment.url + 'ContactPage/GetContactPages').subscribe(data => {
      this.ContactPages = data.Data;
    });
  }

  gotoPageEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/cms/edit-contact-page'], navigatioExtra);
  }

}
